import { render, staticRenderFns } from "./imagesModal.vue?vue&type=template&id=8afd8a34&scoped=true&"
import script from "./imagesModal.vue?vue&type=script&lang=js&"
export * from "./imagesModal.vue?vue&type=script&lang=js&"
import style0 from "./imagesModal.vue?vue&type=style&index=0&id=8afd8a34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afd8a34",
  null
  
)

export default component.exports